import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton, Highlight } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { PaymentLinkActions } from 'components/PaymentLinkActions/PaymentLinkActions'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { ChannelPayment } from 'types/channels'
import { paymentLinkBuilder } from 'utils/paymentLinkBuilder'
import { getHighlightType, titleCase } from 'utils/utils'

const ICONS_BASE_URL = process.env.ICONS_URL

interface ChannelPaymentSidePanelHeaderProps {
  channelPayment: ChannelPayment
}

export const ChannelPaymentSidePanelHeader = ({
  channelPayment,
}: ChannelPaymentSidePanelHeaderProps) => {
  const { t } = useTranslation()

  const headerIconUrls = channelPayment?.paidCurrency?.toLowerCase()
    ? [`${ICONS_BASE_URL}${channelPayment?.paidCurrency?.toLowerCase()}.svg`]
    : []

  const channelLink =
    paymentLinkBuilder({
      uuid: channelPayment?.channelId,
      paymentType: 'channel',
    }) || ''

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: headerIconUrls,
        primaryLabel: `${channelPayment?.paidAmount} ${channelPayment?.paidCurrency}`,
        secondaryLabel: channelPayment?.merchantDisplayName,
      }}
    >
      <Box>
        <Box className="pl-10">
          <Box flex>
            <p className="text-foreground-prominent text-body-regular">
              {ellipseMiddleText(channelPayment?.reference, 10, 10)}
            </p>
            <CopyButton copyText={channelPayment?.reference} />
          </Box>
          <Box className="mt-2">
            <Highlight type={getHighlightType(channelPayment?.status?.toUpperCase())}>
              {titleCase(channelPayment?.status)}
            </Highlight>
          </Box>
        </Box>
        <Box className="mt-6">
          <PaymentLinkActions
            link={channelLink}
            openLinkText={t('openChannelLink')}
            copyLinkText={t('copyChannelLink')}
          />
        </Box>
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}
